import {
  GetScheduleDetails,
  Schedule,
  ScheduleResource,
} from "@mikros/library";
import {
  Grid,
  GridColumn,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridSortChangeEvent,
} from "@progress/kendo-react-grid";
import { useEffect, useRef, useState } from "react";
import { RoundedTab, RoundedTabGroup } from "../../analytics/roundedAnalytics";
import { format } from "date-fns";
import { FormattedMessage, useIntl } from "react-intl";
import {
  CompositeFilterDescriptor,
  SortDescriptor,
  filterBy,
  orderBy,
} from "@progress/kendo-data-query";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { Button } from "@progress/kendo-react-buttons";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";

interface PageState {
  skip: number;
  take: number;
}
const initialDataState: PageState = { skip: 0, take: 10 };

export interface ScheduleDetailsProps {
  currentSchedule: ScheduleResource;
  scheduleModel: GetScheduleDetails;
  schedule: Schedule;

  homeScreenState: Function;
  fetchScreenState: Function;
}

export function ScheduleDetailsFetch(props: ScheduleDetailsProps) {
  const accountInstance = Account.getInstance();
  const intl = useIntl();
  const navigate = useNavigate();
  const errorInstance = ErrorHandler.getErrorInstance();

  // Maps boolean values to internationalized strings for course options
  // Used to display whether user response is required for the schedule
  // true -> "Course Option 1" message
  // false -> "Course Option 2" message
  const isUserRespReqrd = {
    true: intl.formatMessage({ id: "schedule.createSchedule.courseOption1" }),
    false: intl.formatMessage({ id: "schedule.createSchedule.courseOption2" }),
  };

  const containerRef = useRef(null);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  console.log(
    "schedule course option",
    props?.scheduleModel?.schedule?.scheduleInfo?.endOption?.courseEnd
  );

  const languageCodeToLanguage: Record<string, string> = {
    en_US: intl.formatMessage({
      id: "schedule.course.templateLanguage.English",
    }),
    ta: intl.formatMessage({ id: "schedule.course.templateLanguage.Tamil" }),
  };

  console.log(
    "check every parameter",
    props?.scheduleModel?.schedule?.scheduleInfo?.every
  );

  const chapterLang = intl.formatMessage({
    id: "scheduleDetails.chapter",
  });
  const andCardLang = intl.formatMessage({
    id: "scheduleDetails.andCard",
  });
  const channels = props?.scheduleModel?.schedule?.channels;
  const formattedChannels = channels?.map(
    (channel: string) =>
      channel?.charAt(0)?.toUpperCase() + channel?.slice(1)?.toLowerCase()
  );

  const initialSort: Array<SortDescriptor> = [
    { field: "userProfile.firstName", dir: "asc" },
  ];
  const [sort, setSort] = useState(initialSort);

  const initialFilter: CompositeFilterDescriptor = {
    logic: "or",
    filters: [],
  };

  const [filter, setFilter] = useState(initialFilter);

  const [filteredData, setFilteredData] = useState<any>([]);

  const [page, setPage] = useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >();

  // const pageChange = (event: GridPageChangeEvent) => {
  //   const targetEvent = event.targetEvent as PagerTargetEvent;
  //   const take =
  //     targetEvent.value === <FormattedMessage id="allValue"></FormattedMessage>
  //       ? filteredData.length
  //       : event.page.take;

  //   if (targetEvent.value) {
  //     setPageSizeValue(targetEvent.value);
  //   }
  //   setPage({
  //     ...event.page,
  //     take,
  //   });
  // };

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const isAllSelected = targetEvent.value === "All";

    const take = isAllSelected ? filteredData.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }

    setPage({
      ...event.page,
      take,
    });
  };

  console.log("print filter", filter);
  console.log("print filtered data", filteredData);
  console.log(
    "schedule details progress",
    props.scheduleModel.schedule.certificateReq
  );

  useEffect(() => {
    console.log("inside react use effect");
    let filterInputs = document.querySelectorAll(
      ".k-filtercell-wrapper .k-textbox .k-input-inner"
    );
    console.log("filter input", filterInputs);
    if (filterInputs.length > 0) {
      filterInputs.forEach((el) => {
        el.setAttribute(
          "placeholder",
          intl.formatMessage({ id: "searchPlaceholder" })
        );
      });
    }
  }, [filteredData]);

  useEffect(() => {
    setFilteredData(
      filter
        ? filterBy(props?.scheduleModel?.userSchedules, filter)
        : props?.scheduleModel?.userSchedules
    );
  }, [filter, props?.scheduleModel?.userSchedules]);

  const goToSchedules = () => {
    props.homeScreenState(true);
    props.fetchScreenState(false);
  };

  const onFilterChange = (event: GridFilterChangeEvent) => {
    setFilter(event?.filter);

    setFilteredData(
      filter
        ? filterBy(
            (props?.scheduleModel?.userSchedules).slice(
              page.skip,
              page.take + page.skip
            ),
            filter
          )
        : props?.scheduleModel?.userSchedules
    );
  };

  const mapEveryValue = (inputValue: any) => {
    switch (inputValue) {
      case "FOM":
        return intl.formatMessage({
          id: "schedule.deliverySchedule.1stOfMonth",
        });
      case "FMOM":
        return intl.formatMessage({
          id: "schedule.deliverySchedule.1stMondayOfMonth",
        });
      case "15OM":
        return intl.formatMessage({
          id: "schedule.deliverySchedule.15thOfMonth",
        });
      case "LFOM":
        return intl.formatMessage({
          id: "schedule.deliverySchedule.lastFridayOfMonth",
        });
      case "LOM":
        return intl.formatMessage({
          id: "schedule.deliverySchedule.lastDayOfMonth",
        });
      default:
        return inputValue;
    }
  };

  const mapUserReportStatus = (inputValue: any) => {
    console.log("input value print in map user report status", inputValue);
    switch (inputValue) {
      case "NOT_STARTED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.notStarted",
        });
      case "STARTED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.started",
        });
      case "IN_PROGRESS":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.inProgress",
        });
      case "PAUSED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.paused",
        });
      case "COMPLETED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.completed",
        });
      case "FAILED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.failed",
        });
      case "CANCELLED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.cancelled",
        });
    }
  };

  const mapFrequencyEnglish = (inputValue: any) => {
    const repeatsEvery = intl.formatMessage({
      id: "scheduleDetails.frequency.repeatsEvery",
    });
    const hours = intl.formatMessage({
      id: "scheduleDetails.frequency.hours",
    });
    const days = intl.formatMessage({
      id: "scheduleDetails.frequency.days",
    });
    switch (inputValue) {
      case "PRECISELY":
        return intl.formatMessage({
          id: "schedule.landingpage.frequency.REMI",
        });
      case "HOURLY":
        return `${repeatsEvery} ${props?.scheduleModel?.schedule?.scheduleInfo?.every} ${hours}`;
      case "DAILY":
        return `${repeatsEvery} ${props?.scheduleModel?.schedule?.scheduleInfo?.every} ${days}`;
      case "WEEKLY":
        return intl.formatMessage({
          id: "schedule.landingpage.frequency.REWE",
        });
      case "MONTHLY":
        return intl.formatMessage({
          id: "schedule.landingpage.frequency.REMO",
        });
      default:
        return inputValue;
    }
  };

  const mapStatusValue = (inputValue: any) => {
    switch (inputValue) {
      case "COMPLETED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.completed",
        });
      case "IN_PROGRESS":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.inProgress",
        });
      case "PAUSE":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.paused",
        });
      case "STOPPED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.stopped",
        });
      case "ACTIVE":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.active",
        });
      case "SCHEDULED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.scheduled",
        });
      case "CANCELLED":
        return intl.formatMessage({
          id: "scheduleDetails.userReportStatus.cancelled",
        });

      default:
        return inputValue;
    }
  };

  const everyScheduleStatus = mapStatusValue(
    props?.scheduleModel?.schedule?.status
  );

  const everyFrequencyMapped = mapFrequencyEnglish(
    props?.scheduleModel?.schedule?.scheduleInfo?.frequency
  );

  const everyMapped = mapEveryValue(
    props?.scheduleModel?.schedule?.scheduleInfo?.every
  );
  console.log("mapped parameter", everyMapped);

  const dateString = props.scheduleModel.schedule.startDate;

  console.log("print date string", dateString);
  const dateObject = new Date(dateString);
  console.log("print date object", dateObject);
  const extractedDate = dateString?.split("T")[0];
  console.log("print extracted date", extractedDate);

  console.log(
    "print curr schedule in schedule details fetch screen",
    props.currentSchedule
  );

  const enrolmntType = {
    ALL_COHORT_USER: intl.formatMessage({
      id: "schedule.createSchedule.cohortEnrolledOption1",
    }),
    COHORT: intl.formatMessage({
      id: "schedule.createSchedule.cohortEnrolledOption2",
    }),
    COHORT_USER: intl.formatMessage({
      id: "schedule.createSchedule.cohortEnrolledOption3",
    }),
  };

  const courseEnd = {
    true: intl.formatMessage({
      id: "schedule.createSchedule.deliveryScheduleEndOption1",
    }),
    false: intl.formatMessage({
      id: "schedule.createSchedule.deliveryScheduleOccurence",
    }),
  };

  const getWeeklyOn = (): string => {
    let on = props?.scheduleModel?.schedule?.scheduleInfo?.on!![0];

    props?.scheduleModel?.schedule?.scheduleInfo?.on?.forEach(
      (ele: string, i: number) => {
        if (i != 0) {
          on = on + ", " + ele;
        }
      }
    );

    const daysMapping: any = {
      SUN: intl.formatMessage({ id: "sunday" }),
      MON: intl.formatMessage({ id: "monday" }),
      TUE: intl.formatMessage({ id: "tuesday" }),
      WED: intl.formatMessage({ id: "wednesday" }),
      THU: intl.formatMessage({ id: "thursday" }),
      FRI: intl.formatMessage({ id: "friday" }),
      SAT: intl.formatMessage({ id: "saturday" }),
    };
    const formattedDays = on
      .split(", ")
      .map((day: any) => daysMapping[day] || day)
      .join(", ");

    return formattedDays;
  };
  const isSchdlReqrd = {
    true: intl.formatMessage({
      id: "schedule.createSchedule.deliveryScheduleTypeOption1",
    }),
    false: intl.formatMessage({
      id: "schedule.createSchedule.deliveryScheduleTypeOption2",
    }),
  };
  const cohortOption = {
    NEW_USERS_NO: intl.formatMessage({
      id: "schedule.createSchedule.cohortOption1",
    }),
    NEW_USERS_STRT_FIRST: intl.formatMessage({
      id: "schedule.createSchedule.cohortOption2",
    }),
  };

  function resetTabs(tabName: string) {}

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  return (
    <div className="flex">
      <div className="w-full">
        {errorFlag && (
          <Dialog className="errorDialogue">
            <Alert
              description={intl.formatMessage({
                id: errorInstance.errorCode,
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"errorShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgError",
              })}
              backgroundColor={"mk-red"}
              onClick={() => {
                setErrorFlag(false);
                if (errorInstance.permDenied === true) {
                  navigate("/home");
                } else {
                  navigate("/scheduler");
                }
              }}
            />
          </Dialog>
        )}
        <RoundedTabGroup defaultTabName="progress" onClick={resetTabs}>
          <RoundedTab
            name="progress"
            title={intl.formatMessage({ id: "scheduleDetails.progressTab" })}
          >
            <div className="w-full flex justify-end items-center mt-[-2.5rem] right-12 top-20">
              <Button
                className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                onClick={goToSchedules}
              >
                {intl.formatMessage({ id: "backButton" })}
              </Button>
            </div>

            <div className="pb-10"></div>

            <div className="grid grid-cols-2 space-x-6 text-medium">
              <div className="flex flex-col gap-4">
                <div className="flex space-x-2">
                  <div className="font-bold w-28">
                    {/* Schedule Name: */}
                    {intl.formatMessage({
                      id: "analytics.summaryDisplay.scheduleName",
                    })}
                    :
                  </div>
                  <div>{props.scheduleModel.schedule.scheduleName}</div>
                </div>
                <div className="flex space-x-2">
                  <div className="font-bold w-28">
                    {" "}
                    {intl.formatMessage({
                      id: "analytics.summaryDisplay.courseName",
                    })}
                    :
                  </div>
                  <div>{props.scheduleModel.schedule.courseName}</div>
                </div>
                <div className="flex space-x-2">
                  <div className="font-bold w-28">
                    {intl.formatMessage({
                      id: "analytics.scheduleDisplay.cohortName",
                    })}
                    :
                  </div>
                  <div>{props.scheduleModel.schedule.cohortName}</div>
                </div>
                <div className="flex space-x-2">
                  <div className="font-bold w-28">
                    {intl.formatMessage({
                      id: "user.createUser.status",
                    })}
                    :
                  </div>
                  <div>{everyScheduleStatus}</div>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div className="flex space-x-2">
                  <div className="font-bold w-32">
                    {intl.formatMessage({
                      id: "schedule.createSchedule.deliveryScheduleSelect.startDate",
                    })}
                    :
                  </div>

                  <div>
                    {props.scheduleModel.schedule.startDate &&
                      format(
                        new Date(props.scheduleModel.schedule.startDate),
                        "dd-MMM-yyyy"
                      ) +
                        " at " +
                        format(
                          new Date(props.scheduleModel.schedule.startDate),
                          "hh:mm a"
                        )}
                  </div>
                </div>
                <div className="flex space-x-2">
                  <div className="font-bold w-32">
                    {intl.formatMessage({
                      id: "schedule.createSchedule.deliveryScheduleSelect.freq",
                    })}
                    :
                  </div>

                  <div>{everyFrequencyMapped}</div>
                </div>
                <div className="flex space-x-2">
                  <div className="font-bold w-32">
                    {intl.formatMessage({
                      id: "scheduleDetails.channel",
                    })}
                    :
                  </div>
                  <div>{formattedChannels}</div>
                </div>

                <div>
                  <div className="flex space-x-2">
                    <div className="font-bold w-32">
                      {" "}
                      {intl.formatMessage({
                        id: "scheduleDetails.numberOfUsers",
                      })}
                      :
                    </div>
                    <div>{props.scheduleModel.userSchedules?.length}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-5"></div>
            <div className="pt-5"></div>

            <div className="w-full" ref={containerRef}>
              {filteredData ? (
                <Grid
                  rowHeight={48}
                  data={orderBy(
                    filteredData.slice(page.skip, page.take + page.skip),
                    sort
                  )}
                  style={{ border: 0 }}
                  skip={page.skip}
                  take={page.take}
                  total={filteredData?.length}
                  pageable={{
                    buttonCount: 4,
                    pageSizes: [
                      5,
                      10,
                      15,
                      // "All"
                      intl.formatMessage({ id: "allValue" }),
                    ],
                    pageSizeValue: pageSizeValue,
                  }}
                  onPageChange={pageChange}
                  filterable={true}
                  filter={filter}
                  sortable={true}
                  sort={sort}
                  onFilterChange={onFilterChange}
                  onSortChange={(e: GridSortChangeEvent) => {
                    setSort(e.sort);
                  }}
                >
                  <GridColumn
                    title={intl.formatMessage({ id: "slNo" })}
                    headerClassName="custom-header2 w-[5%]"
                    resizable={true}
                    filterable={false}
                    cell={(props) => (
                      <td className="custom-column center-align-cell">
                        {props.dataIndex + 1}
                      </td>
                    )}
                  />

                  <GridColumn
                    field="userProfile.firstName"
                    title={intl.formatMessage({
                      id: "analytics.scheduleDisplay.userName",
                    })}
                    headerClassName="custom-header2 w-[17%]"
                    cell={(props) => (
                      <td className="custom-column6">
                        {props?.dataItem?.userProfile?.firstName}{" "}
                        {props?.dataItem?.userProfile?.lastName}
                      </td>
                    )}
                    resizable={true}
                  />

                  <GridColumn
                    field="lastSentChapterName"
                    title={intl.formatMessage({
                      id: "scheduleDetails.lastSentChapterAndCard",
                    })}
                    headerClassName="custom-header2 w-[35%]"
                    cell={(props) => (
                      <td className="custom-column4">
                        {props?.dataItem?.lastSentChapterSeqNo === 0 ||
                        props?.dataItem?.lastSentChapterName ===
                          intl.formatMessage({
                            id: "scheduleDetails.notApplicable",
                          }) ||
                        props?.dataItem?.lastSentCardSeqNo === 0
                          ? intl.formatMessage({ id: "scheduleDetails.na" })
                          : `${chapterLang} ${props?.dataItem?.lastSentChapterSeqNo}: ${props?.dataItem?.lastSentChapterName} ${andCardLang} ${props?.dataItem?.lastSentCardSeqNo}`}
                      </td>
                    )}
                    resizable={true}
                  />

                  <GridColumn
                    field="userProgress"
                    title={intl.formatMessage({
                      id: "scheduleDetails.progressCompleted",
                    })}
                    headerClassName="custom-header2 w-[15%]"
                    cell={(props) => (
                      // <td>
                      <td className="custom-column3">
                        {props?.dataItem?.userProgress}%
                      </td>
                    )}
                    resizable={true}
                  />
                  <GridColumn
                    field="courseScore"
                    title={intl.formatMessage({
                      id: "scheduleDetails.assessmentScore",
                    })}
                    headerClassName="custom-header2 w-[15%]"
                    cell={(props) => (
                      <td className="custom-column3">
                        {props?.dataItem?.courseScoreV2?.courseScore != null
                          ? `${props?.dataItem?.courseScoreV2?.courseScore}%`
                          : `0%`}
                      </td>
                    )}
                    resizable={true}
                  />
                  <GridColumn
                    field="userReportStatus"
                    title={intl.formatMessage({ id: "user.createUser.status" })}
                    headerClassName="custom-header2 w-[15%]"
                    resizable={true}
                    cell={(props) => (
                      // <td>
                      <td className="custom-column3">
                        {mapUserReportStatus(props?.dataItem?.userReportStatus)}
                      </td>
                    )}
                  />
                </Grid>
              ) : (
                <div></div>
              )}
              <div className="pb-[10%]"></div>
            </div>
          </RoundedTab>
          <RoundedTab name="details" title="Details">
            <div className="w-full flex justify-end items-center mt-[-2.5rem] right-12 top-20">
              <Button
                className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
                onClick={goToSchedules}
              >
                <FormattedMessage id="backButton" />
              </Button>
            </div>
            <div className="pb-10"></div>

            <div className="flex flex-col gap-2">
              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* Schedule Name: */}
                  <FormattedMessage id="analytics.summaryDisplay.scheduleName" />
                  :
                </div>
                <div>{props.scheduleModel.schedule.scheduleName}</div>
              </div>

              <div className="pb-2"></div>

              <div className="font-bold text-base p-2">
                {/* Course Details: */}
                <FormattedMessage id="schedule.createSchedule.finish.courseDetails" />
                :
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* Course Name */}
                  <FormattedMessage id="courses.onClickCourse.courseName" />
                </div>
                <div>{props.scheduleModel.schedule.courseName}</div>
              </div>
              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* Course Option */}
                  <FormattedMessage id="schedule.createSchedule.finish.courseDetails.option" />
                </div>

                <div className="">
                  {props.scheduleModel.schedule.isUserRespReqrd
                    ? isUserRespReqrd.true
                    : isUserRespReqrd.false}
                </div>
              </div>
              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* Welcome Message */}
                  <FormattedMessage id="schedule.createSchedule.finish.courseDetails.welcomeMessage" />
                </div>
                <div>{props.scheduleModel.schedule.description}</div>
              </div>

              <div className="pb-2"></div>

              <div className="font-bold text-base p-2">
                {/* Cohort Details: */}
                <FormattedMessage id="schedule.createSchedule.finish.cohortDetails" />
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* Cohort Name */}
                  <FormattedMessage id="schedule.createSchedule.finish.cohortDetails.cohortName" />
                </div>
                <div>{props.scheduleModel.schedule.cohortName}</div>
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* User Enrollment */}
                  <FormattedMessage id="schedule.createSchedule.finish.cohortDetails.enrollement" />
                </div>

                <div className="">
                  {props.scheduleModel.schedule.enrolmntType ===
                  "ALL_COHORT_USER"
                    ? enrolmntType.ALL_COHORT_USER
                    : props.scheduleModel.schedule.enrolmntType === "COHORT"
                    ? enrolmntType.COHORT
                    : enrolmntType.COHORT_USER}
                </div>
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">Cohort Options</div>

                {/* <div>No Cohort option</div> */}
                <div className="">
                  {props.schedule.isNewUserAllowed === "NEW_USERS_NO"
                    ? cohortOption.NEW_USERS_NO
                    : props.schedule.isNewUserAllowed === "NEW_USERS_STRT_FIRST"
                    ? cohortOption.NEW_USERS_STRT_FIRST
                    : cohortOption.NEW_USERS_NO}
                </div>
              </div>

              <div className="pb-2"></div>

              <div className="font-bold text-base p-2">
                {/* Schedule Details: */}
                <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails" />
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* Delivery Method */}
                  <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.deliverMethod" />
                </div>
                <div>{formattedChannels}</div>
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* Delivery Type */}
                  <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.deliveryType" />
                </div>

                <div className="">
                  {props.scheduleModel.schedule.isSchdlReqrd
                    ? isSchdlReqrd.true
                    : isSchdlReqrd.false}
                </div>
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* Start Date */}
                  <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.sDate" />
                </div>

                <div>
                  {props.scheduleModel.schedule.startDate &&
                    format(
                      new Date(props.scheduleModel.schedule.startDate),
                      "dd-MMM-yyyy"
                    ) +
                      " " +
                      intl.formatMessage({ id: "atLang" }) +
                      " " +
                      format(
                        new Date(props.scheduleModel.schedule.startDate),
                        "hh:mm a"
                      )}
                </div>
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  {/* Frequency */}
                  <FormattedMessage id="schedule.createSchedule.deliveryScheduleSelect.freq" />
                </div>
                <div>{everyFrequencyMapped}</div>
              </div>

              {props?.scheduleModel?.schedule?.scheduleInfo?.every &&
              props?.scheduleModel?.schedule?.scheduleInfo?.frequency.toLowerCase() !==
                "weekly" &&
              !["hourly", "daily"].includes(
                props?.scheduleModel?.schedule?.scheduleInfo?.frequency.toLowerCase()
              ) ? (
                <div className="flex space-x-2">
                  <div className="font-bold pl-4 w-64">On</div>
                  <div className="">{everyMapped}</div>
                </div>
              ) : props?.scheduleModel?.schedule?.scheduleInfo?.on &&
                !["hourly", "daily"].includes(
                  props?.scheduleModel?.schedule?.scheduleInfo?.frequency.toLowerCase()
                ) ? (
                <div className="flex space-x-2">
                  <div className="font-bold pl-4 w-64"> On</div>
                  <div>{getWeeklyOn()}</div>
                </div>
              ) : null}
              <div className="flex space x-2">
                <div className="font-bold pl-4 w-64">
                  {" "}
                  <FormattedMessage id="schedule.createSchedule.deliveryScheduleContent.card" />
                </div>
                <div className="pl-2">
                  {props?.scheduleModel?.schedule?.cardsPerSchedule}{" "}
                  {/* cards */}
                  <FormattedMessage id="courses.courseCard.cards" />
                </div>
              </div>

              <div className="flex space x-2">
                <div className="font-bold pl-4 w-64">
                  {/* No. Of Questions Per Chapter */}
                  <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.cardsPerChapter" />{" "}
                </div>
                <div className="pl-2">
                  {props?.scheduleModel?.schedule?.assessQuesCnt}{" "}
                  {/* questions */}
                  <FormattedMessage id="schedule.finish.questions" />
                </div>
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.templateLanguage" />
                </div>
                <div className="">
                  {
                    languageCodeToLanguage[
                      props?.scheduleModel?.schedule?.languageCode!!
                    ]
                  }
                </div>
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.reminderOpition" />
                </div>
                <div className="">
                  {props.scheduleModel?.schedule?.isReminderReqrd ? (
                    <FormattedMessage id="schedule.deliverySchedule.Yes" />
                  ) : (
                    <FormattedMessage id="schedule.deliverySchedule.No" />
                  )}
                </div>
              </div>

              <div className="flex space-x-2">
                <div className="font-bold pl-4 w-64">
                  <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.certificateOption" />
                </div>
                <div className="">
                  {props.scheduleModel.schedule.certificateReq ? (
                    <FormattedMessage id="schedule.deliverySchedule.Yes" />
                  ) : (
                    <FormattedMessage id="schedule.deliverySchedule.No" />
                  )}
                </div>
              </div>

              {props?.scheduleModel?.schedule?.scheduleInfo?.endOption
                ?.courseEnd ? (
                <div className="flex space-x-2">
                  <div className="font-bold pl-4 w-64">
                    {/* Ends After */}
                    <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.endsAfter" />
                  </div>
                  <div className="">{courseEnd.true}</div>
                </div>
              ) : (
                <div className="flex space-x-2">
                  <div className="font-bold pl-4 w-64">
                    {/* Occurences */}
                    <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.occurances" />
                  </div>
                  <div className="">
                    {
                      props?.scheduleModel?.schedule?.scheduleInfo?.endOption
                        ?.occurence
                    }
                  </div>
                </div>
              )}
            </div>
            <div className="pb-[10%]"></div>
          </RoundedTab>
        </RoundedTabGroup>
      </div>

      <div className="pb-[10%]"></div>
    </div>
  );
}
